import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./index.module.css";
import viewStyles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../components/ToastMsg";
import BeatLoader from "react-spinners/BeatLoader";
import { Link, useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import { selectUserDetails } from "../../../../redux/features/auth/authSlice";
import InvoicePDF from "../../../../components/Receipts/Invoice";
import { getVehicleById } from "../../../../redux/features/vehicle/vehicleService";
import { addNewQuotation, saveQuotationDocument } from "../../../../redux/features/quotation/quotationService";

const MONTHS = [
  { id: 1, name: "01" },
  { id: 2, name: "02" },
  { id: 3, name: "03" },
  { id: 4, name: "04" },
  { id: 5, name: "05" },
  { id: 6, name: "06" },
  { id: 7, name: "07" },
  { id: 8, name: "08" },
  { id: 9, name: "09" },
  { id: 10, name: "10" },
  { id: 11, name: "11" },
  { id: 12, name: "12" }
];

function getMonthOptions(selectedYear) {
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();

  if (selectedYear == currentYear) {
    return MONTHS.slice(0, currentMonthIndex + 1).reverse();
  }

  return MONTHS;
}

const Invoice = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { details } = useSelector(selectUserDetails);
  const { isVehicleLoading, vehicle } = useSelector((state) => state.vehicle.vehicle);

  const [vehicles, setVehicles] = useState([]);
  const [qrLink, setQrLink] = useState(null);

  const { isQuotationCreating } = useSelector(
    (state) => state.quotation.newQuotation
  );
  const [formData, setFormData] = useState({});

  const [errorMessages, setErrorMessages] = useState({});
  const [selectedBank, setSelectedBank] = useState(null);
  const [isNotifyParty, setNotifyParty] = useState(false);

  useEffect(() => {
    dispatch(getVehicleById({ id })).unwrap();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrorMessages((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  // Validate input
  const isValidQuotation = () => {
    const errors = {};
    if (!formData.bill_to_name) {
      errors.bill_to_name = "Name is required.";
    }
    if (!formData.bill_to_address) {
      errors.bill_to_address = "Billing address is required.";
    }
    if (!formData.recipient_designation) {
      errors.recipient_designation = "Designation is required.";
    }
    if (!formData.recipient_organization) {
      errors.recipient_organization = "Organization is required.";
    }
    if (!formData.organization_branch) {
      errors.organization_branch = "Branch is required.";
    }
    if (!formData.date) {
      errors.date = "Date is required.";
    }
    if (Object.keys(errors).length > 0) {
      setErrorMessages(errors);
      return false;
    } else {
      return true;
    }
  };

  const data = {
    order_id: 1,
    bill_to_name: "Nimal Perera",
    bill_to_address: "No 12, Main Road",
    city: "Colombo",
    details_line_1: "Sri Lanka",
    quotation_date: "2025-05-24",
    valid_until: "2025-06-24",
    notes: "",
    quotation_status: "Quotation_Created",
  };

  const generateInvoice = async (invoice) => {
    try {
      const pdfBlob = await pdf(
        <InvoicePDF
          data={[
            invoice,
            vehicle,
          ]}
        />
      ).toBlob();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
      dispatch(
        saveQuotationDocument({
          vehicle_quotation_file: pdfBlob,
          invoice_id: invoice.id,
        })
      );
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const submitQuotation = async () => {
    if (isValidQuotation()) {
      const data = {
        vehicle_id: +id,
        bill_to_name: formData.bill_to_name,
        bill_to_address: formData.bill_to_address,
        recipient_designation: formData.recipient_designation,
        recipient_organization: formData.recipient_organization,
        organization_branch: formData.organization_branch,
        date: formData.date,
      };
      try {
        const response = await dispatch(addNewQuotation(data)).unwrap();
        showToast("success", response.message);
        await generateInvoice(response?.vehicle_quotation);
        navigate(`/admin/vehicles/${id}/invoices`)
      } catch (error) {
        showToast("error", error.message);
      }
    }
  };

  const viewInvoice = (document) => {
    window.open(document.invoice_document, "_blank");
  };

  return (
    <div className={`card-section`}>
      <div
        className={`main-card`}
        style={{
          minHeight: "max-content",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h1 className={`form-title`}>Invoice</h1>
        <div className={styles.formContainer}>
          {/* Invoices */}
          <div className={styles.vehicleFormGroup}>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Bill to Name<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type='text'
                    id='bill_to_name'
                    name='bill_to_name'
                    value={formData.bill_to_name || ''}
                    onChange={handleInputChange}
                    className={`form-input-default`}
                    placeholder="Enter Name"
                  />
                  {errorMessages.bill_to_name && (
                    <p className={`text-danger`}>{errorMessages.bill_to_name}</p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Billing Address<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type='text'
                    id='bill_to_address'
                    name='bill_to_address'
                    value={formData.bill_to_address || ''}
                    onChange={handleInputChange}
                    className={`form-input-default`}
                    placeholder="Enter Address"
                  />
                  {errorMessages.bill_to_address && (
                    <p className={`text-danger`}>{errorMessages.bill_to_address}</p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Recipient Designation<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type='text'
                    id='recipient_designation'
                    name='recipient_designation'
                    value={formData.recipient_designation || ''}
                    onChange={handleInputChange}
                    className={`form-input-default`}
                    placeholder="Enter Name"
                  />
                  {errorMessages.recipient_designation && (
                    <p className={`text-danger`}>{errorMessages.recipient_designation}</p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Recipient Organization<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type='text'
                    id='recipient_organization'
                    name='recipient_organization'
                    value={formData.recipient_organization || ''}
                    onChange={handleInputChange}
                    className={`form-input-default`}
                    placeholder="Enter Address"
                  />
                  {errorMessages.recipient_organization && (
                    <p className={`text-danger`}>{errorMessages.recipient_organization}</p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Organization Branch<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type='text'
                    id='organization_branch'
                    name='organization_branch'
                    value={formData.organization_branch || ''}
                    onChange={handleInputChange}
                    className={`form-input-default`}
                    placeholder="Enter Address"
                  />
                  {errorMessages.organization_branch && (
                    <p className={`text-danger`}>{errorMessages.organization_branch}</p>
                  )}
                </div>
              </div>
            </div>
            <div className={`form-input-row`}>
              <div className={`form-input-col md-col`}>
                <div className={`form-input-group`}>
                  <label htmlFor='full_name' className={`form-label`}>
                    Date<span className={`required-star`}>*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    value={formData.date || ""}
                    onChange={handleInputChange}
                    className={`form-input-default`}
                  />
                  {errorMessages.date && (
                    <p className={`text-danger`}>{errorMessages.date}</p>
                  )}
                </div>
              </div>
            </div>
            <button
              className={`btn-primary`}
              type="button"
              disabled={isQuotationCreating}
              onClick={submitQuotation}
              style={{ marginTop: "20px" }}
            >
              {isQuotationCreating ? <BeatLoader /> : `Create Invoice`}
            </button>
          </div>
        </div>
        <PDFViewer width="100%" height="800px" style={{ marginTop: "20px" }}>
          <InvoicePDF
            data={[formData, vehicle]}
          />
        </PDFViewer>
      </div>
    </div >
  );
};

export default Invoice;